import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import configureStore from "./configureStore";
import * as controlPanelActions from "./actions/controlPanelActions";
import * as authActions from "./actions/authActions";

import Content from "./components/main/Content";
import { Helmet, HelmetProvider } from "react-helmet-async";

import "./jquery-global.js";
import "./App.css";
import "../node_modules/bootstrap/dist/css/bootstrap.css";
import "../node_modules/draft-js/dist/Draft.css";
import "./assets/fa5/css/all.min.css";
// import "./assets/css/AlabasterBase.css";
import "./assets/css/Alabaster.css";

const store = configureStore();
class App extends Component {
	constructor(props) {
		super(props);
		store.dispatch(controlPanelActions.controlPanelInit());
	}

	componentDidMount() {
		store.dispatch(authActions.trackAuthStatus());
	}

	render() {
		let mode = "light";
		if (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches) {
			mode = "dark";
		}

		const icon = () => {
			if (mode === "dark") {
				return "favicon-dark.png";
			} else if (mode === "light") {
				return "favicon.png";
			}
		};
		return (
			<Provider store={store}>
				<HelmetProvider>
					<Helmet>
						<link rel="icon" href={`/img/${icon()}`} />
						<link rel="apple-touch-icon" href={`/img/${icon()}`} />
						<link rel="shortcut icon" href={`/img/${icon()}`} />
					</Helmet>
					<Router>
						<div className="app">
							<Content />
						</div>
					</Router>
				</HelmetProvider>
			</Provider>
		);
	}
}

export default App;
